<!-- Cachebuster: 25 (used to clear cache on bit.dev, update if builds are not updated) -->
<template>
  <div class="ft-bonus" @click="$emit('clicked-bonus', pendingBonus.Id)" :class="{'ft-bonus--locked-locked': bonusNeedsDeposit, 'bonus--unlocked': bonusUnlocked}">
    <img :src="pendingBonus.ImageUrl" />
    <h4 class="title" v-if="pendingBonus.Custom && pendingBonus.Custom.Title" v-html="pendingBonus.Custom.Title"></h4>
    <p class="date">{{expiryDateString}}</p>
  </div>
</template>

<script>

export default {
  name: 'Listitem',
  props: {
    pendingBonus: {
      type: Object,
    },
    translations: {
      type: Object,
    },
    expiryDateString: {
      type: String,
    },
  },
  computed: {
    bonusUnlocked() {
      return (this.pendingBonus.Type === 3 && this.pendingBonus.IsLocked === 0);
    },
    bonusNeedsDeposit() {
      return this.pendingBonus.Type === 2
        || (this.pendingBonus.Type === 3 && this.pendingBonus.IsLocked === 1);
    },
  },
};
</script>

<style lang="less">
#fasttrack-crm {
  .ft-bonus {
    font-family: "Lato", sans-serif;
    width: 48%;
    display: inline-block;
    margin-bottom: 20px;
    cursor: pointer;
    vertical-align: top;

    img {
      width: 100%;
      display: block;
    }

    &:nth-child(even) {
      margin-left: 4%;
    }

    &:hover {
      transform: scale(1.05);
      transition: all 0.1s linear;
    }

    h4.title {
      font-family: "Lato", sans-serif;
      margin: 0;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      padding: 5px;
      font-weight: 800;
    }

    p.date {
      font-family: "Lato", sans-serif;
      margin: 0;
      font-size: 10px;
      line-height: 10px;
      text-align: center;
      color: rgba(51, 51, 51, 0.6);
    }
  }
}
</style>
